import { useGetHttp } from "../../../../hooks/http/http.hook";
import type { IProposalSocial } from "./get-proposal-socials.hook";

interface IResponse {
  campaignProposalSocials: Array<IProposalSocial>;
}

export function useGetProposalSocialsUnauthenticatedHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/campaigns/proposals/socials",
  });
}
